export default __webpack_public_path__ + "static/media/CNo.48-3.12bfe41f.jpg";